import { OrganizationConfig } from "@idw-types/data/organization-config";
import { IdentityProviderDetailsReferenceData } from "@idw-types/state/identity-provider-details-state";

export enum OrganizationDetailsActionTypes {
    SET_ORGANIZATION_DETAILS_LOADING = "SET_ORGANIZATION_DETAILS_LOADING",
    SET_ORGANIZATION_DETAILS = "SET_ORGANIZATION_DETAILS",
    SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING = "SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING",
    SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA = "SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA"
}

type SetOrganizationDetailsLoadingAction = {
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationDetailsLoading = (isLoading: boolean): SetOrganizationDetailsLoadingAction => ({
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_LOADING,
    payload: { isLoading }
});

type SetOrganizationDetailsAction = {
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS,
    payload: { organizationConfig: OrganizationConfig; }
}

export const setOrganizationDetails = (organizationConfig: OrganizationConfig): SetOrganizationDetailsAction => ({
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS,
    payload: { organizationConfig }
});

type SetOrganizationDetailsIdentityProvidersReferenceDataLoading = {
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationDetailsIdentityProvidersReferenceDataLoading = (isLoading: boolean): SetOrganizationDetailsIdentityProvidersReferenceDataLoading => ({
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetOrganizationDetailsIdentityProvidersReferenceData = {
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA,
    payload: { referenceData: IdentityProviderDetailsReferenceData; }
};

export const setOrganizationDetailsIdentityProvidersReferenceData = (referenceData: IdentityProviderDetailsReferenceData): SetOrganizationDetailsIdentityProvidersReferenceData => ({
    type: OrganizationDetailsActionTypes.SET_ORGANIZATION_DETAILS_IDENTITY_PROVIDERS_REFERENCE_DATA,
    payload: { referenceData }
});

export type OrganizationDetailsActions =
    SetOrganizationDetailsLoadingAction |
    SetOrganizationDetailsAction |
    SetOrganizationDetailsIdentityProvidersReferenceDataLoading |
    SetOrganizationDetailsIdentityProvidersReferenceData;